var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'layout-container': true,
    'layout-income': _vm.cssType == 1,
    'layout-default': _vm.cssType == 0,
  }},[_c('div',{staticClass:"top"},[_vm._t("top")],2),_c('div',{staticClass:"middle"},[_vm._t("default")],2),_c('div',{staticClass:"bottom"},[_vm._t("bottom")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }